"use client";
import { getBaseUrl } from "util/api";
import { useFetchCreator, useObsState } from "../../hooks/rxjs";
import { useMemo } from "react";
import { useWeb3Context } from "../../../contexts/web3";
import { BLAST_CONTEST_ID } from "constants/contest-id";

export const BADGES = [
  {
    position: "1",
    prize: 1500,
    src: "1",
  },
  {
    position: "2",
    prize: 1000,
    src: "2",
  },
  {
    position: "3",
    prize: 500,
    src: "3",
  },
  {
    position: "4-5",
    prize: 400,
    src: "4",
  },
  {
    position: "6-10",
    prize: 240,
    src: "5",
  },
];

export const BADGES_CAMELOT = [
  {
    position: "1",
    prize: 2000,
    src: "1",
  },
  {
    position: "2",
    prize: 1000,
    src: "2",
  },
  {
    position: "3",
    prize: 500,
    src: "3",
  },
  {
    position: "4-5",
    prize: 200,
    src: "4",
  },
  {
    position: "6-10",
    prize: 100,
    src: "5",
  },
  {
    position: "11-20",
    prize: 50,
    src: "6",
  },
  {
    position: "21-50",
    prize: 20,
    src: "7",
  },
];

export const REFER_BADGES = [
  {
    position: "1",
    prize: 300,
    src: "1",
  },
  {
    position: "2",
    prize: 200,
    src: "2",
  },
  {
    position: "3",
    prize: 100,
    src: "3",
  },
  {
    position: "4-5",
    prize: 90,
    src: "4",
  },
  {
    position: "6-10",
    prize: 44,
    src: "5",
  },
];

export const REFER_BADGES_CAMELOT = [
  {
    position: "1",
    prize: 400,
    src: "1",
  },
  {
    position: "2",
    prize: 150,
    src: "2",
  },
  {
    position: "3",
    prize: 100,
    src: "3",
  },
  {
    position: "4-10",
    prize: 50,
    src: "4",
  },
];

const BADGES_IN_TEAM = [
  {
    position: "Rank #1 in team #1",
    prize: 2500,
    src: "best1",
    rank: 1,
    inteam: 1,
  },
  {
    position: "Rank #2 in team #1",
    prize: 1750,
    src: "best2",
    rank: 2,
    inteam: 1,
  },
  {
    position: "Rank #3 in team #1",
    prize: 1000,
    src: "best3",
    rank: 3,
    inteam: 1,
  },
  {
    position: "Rank #4 in team #1",
    prize: 750,
    src: "best4",
    rank: 4,
    inteam: 1,
  },
  {
    position: "Rank #5-10 in team #1",
    prize: 500,
    src: "best5",
    rank: 5,
    inteam: 1,
  },

  {
    position: "Rank #1 in team #2",
    prize: 2000,
    src: "second1",
    rank: 1,
    inteam: 2,
  },
  {
    position: "Rank #2 in team #2",
    prize: 1000,
    src: "second2",
    rank: 2,
    inteam: 2,
  },
  {
    position: "Rank #3 in team #2",
    prize: 500,
    src: "second3",
    rank: 3,
    inteam: 2,
  },
  {
    position: "Rank #4 in team #2",
    prize: 250,
    src: "second4",
    rank: 4,
    inteam: 2,
  },
  {
    position: "Rank #5-10 in team #2",
    prize: 100,
    src: "second5",
    rank: 5,
    inteam: 2,
  },
  {
    position: "Rank #1 in team #3",
    prize: 1500,
    src: "third1",
    rank: 1,
    inteam: 3,
  },
  {
    position: "Rank #2 in team #3",
    prize: 750,
    src: "third2",
    rank: 2,
    inteam: 3,
  },
  {
    position: "Rank #3 in team #3",
    prize: 500,
    src: "third3",
    rank: 3,
    inteam: 3,
  },
  {
    position: "Rank #4 in team #3",
    prize: 250,
    src: "third4",
    rank: 4,
    inteam: 3,
  },
  {
    position: "Rank #5-10 in team #3",
    prize: 100,
    src: "third5",
    rank: 5,
    inteam: 3,
  },
  {
    position: "Rank #1 in team #4",
    prize: 100,
    src: "4th1",
    rank: 1,
    inteam: 4,
  },
  {
    position: "Rank #2 in team #4",
    prize: 500,
    src: "4th2",
    rank: 2,
    inteam: 4,
  },
  {
    position: "Rank #3 in team #4",
    prize: 250,
    src: "4th3",
    rank: 3,
    inteam: 4,
  },
  {
    position: "Rank #4-10 in team #4",
    prize: 100,
    src: "4th4",
    rank: 4,
    inteam: 4,
  },
  {
    position: "Rank #1 in team #5",
    prize: 1000,
    src: "5th1",
    rank: 1,
    inteam: 5,
  },
  {
    position: "Rank #2 in team #5",
    prize: 500,
    src: "5th2",
    rank: 2,
    inteam: 5,
  },
  {
    position: "Rank #3 in team #5",
    prize: 250,
    src: "5th3",
    rank: 3,
    inteam: 5,
  },
  {
    position: "Rank #4-10 in team #5",
    prize: 100,
    src: "5th4",
    rank: 4,
    inteam: 5,
  },
];

// users rating
interface UserUnitType {
  userAddress: string;
  team: string;
  balanceValue: number;
  positionsValue: number;
  type: "Regular" | "Captain";
  network: "Arbitrum" | "Polygon" | "ZkSync";
  pnl: number;
}

export type ByUserResponseType = UserUnitType[];

const validateUserResponse = (raw: any): raw is ByUserResponseType => {
  if (!Array.isArray(raw)) {
    return false;
  }
  if (raw.length == 0) {
    return true;
  }
  const item = raw[0];

  return [
    "userAddress",
    "team",
    "balanceValue",
    "positionsValue",
    "type",
  ].every((key) => Reflect.has(item, key));
};

// teams rating
export interface TeamUnitType {
  team: string;
  balanceValue: number;
  positionsValue: number;
  pnl: number;
}

export type ByTeamResponseType = TeamUnitType[];

const validateTeamResponse = (raw: any): raw is ByTeamResponseType => {
  if (!Array.isArray(raw)) {
    return false;
  }
  if (raw.length == 0) {
    return true;
  }
  const item = raw[0];

  return ["team", "balanceValue", "positionsValue"].every((key) =>
    Reflect.has(item, key),
  );
};

interface ByUser {
  team: string;
}

let cache: Record<string, number> | undefined = undefined;

const cachedTeamSize = (byUserValue?: ByUser[]) => {
  if (!byUserValue?.length || cache) {
    return cache;
  }

  for (const { team } of byUserValue) {
    if (!cache) {
      cache = {};
    }

    if (!cache[team]) {
      cache[team] = 0;
    }

    cache[team]++;
  }

  return cache;
};

const useRating = () => {
  // users rating
  const byUserResponseCreator$ = useFetchCreator({
    validate: validateUserResponse,
  });

  const { internalChainId } = useWeb3Context();

  const byUserQuery = useMemo(
    () => `${getBaseUrl()}/leaderboard/byUser?contestId=${BLAST_CONTEST_ID}`,
    [],
  );

  const byUserObservable = useMemo(
    () => byUserResponseCreator$(byUserQuery),
    [byUserResponseCreator$, byUserQuery],
  );

  const byUserValue = useObsState(byUserObservable);
  const teamSizes = cachedTeamSize(byUserValue);

  // teams rating
  const byTeamResponseCreator$ = useFetchCreator({
    validate: validateTeamResponse,
  });

  const byTeamQuery = useMemo(
    () =>
      internalChainId
        ? `${getBaseUrl()}/leaderboard/chain/${internalChainId}/byTeam`
        : undefined,
    [internalChainId],
  );

  const byTeamObservable = useMemo(
    () => byTeamResponseCreator$(byTeamQuery),
    [byTeamResponseCreator$, byTeamQuery],
  );

  const _byTeamValue = useObsState(byTeamObservable);

  const byTeamValue = useMemo(
    () =>
      _byTeamValue?.sort((a, b) => {
        return b.pnl - a.pnl;
      }),

    [_byTeamValue],
  );

  return {
    BADGES,
    BADGES_IN_TEAM,
    byUserValue,
    byTeamValue,
    teamSizes,
  };
};

export default useRating;
